module.exports = __webpack_public_path__ + "img/husky-sled-factory.6f5c3add.webp";